import { Common_Event_Hit } from "../Actions/UserEvents";
import { Moengage } from "../environments";

const SESSION_KEYS = [
  "currentScreen",
  "currentScreenStartTime",
  "userData",
  "userAuth",
  "userObject",
  "onBehalfRetCode",
  "notificationData",
];

export const logoutUser = async ({ setUserData, setOnBehalfStatus, navigate }) => {
  await Common_Event_Hit("COMMON_EVENT", "logout_tap");
  await Common_Event_Hit("COMMON_EVENT", "logged_out");
  await Common_Event_Hit("SESSION_END", "session_end");
  localStorage.setItem("screenCount", 0);
  SESSION_KEYS.forEach((key) => localStorage.removeItem(key));
  setUserData();
  setOnBehalfStatus(false);
  navigate("/login");
  Moengage.destroy_session();
};
